var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0007 11.0865L16.9504 6.13672L18.3646 7.55093L13.4149 12.5007L18.3646 17.4504L16.9504 18.8646L12.0007 13.9149L7.05093 18.8646L5.63672 17.4504L10.5865 12.5007L5.63672 7.55093L7.05093 6.13672L12.0007 11.0865Z",
    fill: "#667085"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLine);
export default __webpack_public_path__ + "static/media/close-line.24741a5da5bf72659135bafadc9f6b13.svg";
export { ForwardRef as ReactComponent };